import type { ReviewEntryLine } from '../types/reviewEntryLine'

type ReviewEntryAccountLabelSource = Pick<ReviewEntryLine, 'account' | 'accountName' | 'accountNumber'>

export const formatReviewEntryAccountLabel = ({
  account,
  accountName,
  accountNumber,
}: ReviewEntryAccountLabelSource): string | undefined => {
  if (accountNumber && accountName) {
    return `${accountNumber} - ${accountName}`
  }

  return account ?? accountNumber ?? accountName
}
